<template>
   <div class="base-dropdown" v-click-outside="handleClickOutside">
      <div @click="toggle">
         <slot name="trigger" :isOpen="isOpen" />
      </div>

      <transition name="dropdown-fade">
         <div v-if="isOpen" class="base-dropdown-dropdown-content">
            <slot name="default" :close="close" :select="handleSelect" :isOpen="isOpen" />
         </div>
      </transition>
   </div>
</template>

<script>
export default {
   name: "BaseDropdown",
   props: {
      value: {},
      defaultOpen: {
         type: Boolean,
         default: false,
      },
      disableAutoClose: {
         type: Boolean,
         default: false,
      },
   },
   data() {
      return {
         isOpen: this.defaultOpen,
      };
   },
   methods: {
      toggle() {
         // If component is meant to stay open by default (e.g., inline pickers), ignore close on trigger clicks
         if (this.defaultOpen && this.isOpen) return;
         this.isOpen = !this.isOpen;
      },
      open() {
         this.isOpen = true;
      },
      close() {
         if (this.disableAutoClose) return;
         this.isOpen = false;
      },
      handleSelect(val) {
         this.$emit("input", val);
         // this.close();
      },
      handleClickOutside() {
         if (this.isOpen) {
            this.close();
         }
      },
   },
};
</script>

<style lang="scss" scoped>
.base-dropdown {
   position: relative;
   width: 100%;
   .base-dropdown-dropdown-content {
      width: inherit;
      position: absolute;
      // top: calc(100% + 4px);
      // left: 0;
      z-index: 1200;

      // overflow: visible;
   }
}

// Dropdown transition
.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
   transition: opacity 0.2s ease, transform 0.2s ease;
}

.dropdown-fade-enter {
   opacity: 0;
   transform: translateY(-8px);
}

.dropdown-fade-leave-to {
   opacity: 0;
   transform: translateY(-4px);
}
</style>
